/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Page_Book_TitleInputs */

const en_price_page_book_title = /** @type {(inputs: Price_Page_Book_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You see the price before you tap.`)
};

const pl_price_page_book_title = /** @type {(inputs: Price_Page_Book_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cenę widzisz przed kliknięciem.`)
};

/**
* | output |
* | --- |
* | "You see the price before you tap." |
*
* @param {Price_Page_Book_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const price_page_book_title = /** @type {((inputs?: Price_Page_Book_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Page_Book_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_price_page_book_title(inputs)
	return en_price_page_book_title(inputs)
});